import React from 'react';
import { createPortal } from 'react-dom';
import { X, Users, User } from 'lucide-react';

// WhatsApp-style profile photo viewer: dark backdrop + large circular photo.
const ProfilePhotoModal = ({ imageUrl, name, fallbackColor, isGroup, onClose }) => {
  const initials = (name || '')
    .trim()
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 999999,
        background: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        animation: 'fadeInScale 0.18s ease',
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '20px',
          right: '24px',
          background: 'rgba(255,255,255,0.1)',
          border: 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          cursor: 'pointer',
        }}
        aria-label="Close"
      >
        <X size={20} />
      </button>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 'min(320px, 78vw)',
          height: 'min(320px, 78vw)',
          borderRadius: '50%',
          overflow: 'hidden',
          border: '4px solid rgba(255,255,255,0.18)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
          background: imageUrl ? '#000' : (fallbackColor || '#2e7cba'),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={name}
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        ) : isGroup ? (
          <Users size={110} color="#fff" />
        ) : initials ? (
          <span style={{ color: '#fff', fontSize: '84px', fontWeight: '800' }}>{initials}</span>
        ) : (
          <User size={110} color="#fff" />
        )}
      </div>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          color: '#fff',
          fontSize: '18px',
          fontWeight: '700',
          maxWidth: '80vw',
          textAlign: 'center',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {name}
      </div>
    </div>,
    document.body
  );
};

export default ProfilePhotoModal;
